<template>
    <b-container class="px-0">
        <b-row>
            <b-col cols="12">
                <b-input-group>
                    <b-form-input v-model="search_keyword"
                        placeholder="Sub 코드를 입력해 주세요"
                        @keyup.enter="searchSubs(search_keyword)"
                        />
                    <b-input-group-append>
                        <b-btn class="py-1 px-2"
                            variant="dark-border"
                            @click="searchSubs(search_keyword)"
                            >
                            <fa icon="search"></fa>
                        </b-btn>
                    </b-input-group-append>
                </b-input-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col v-show="is_searching_subs">
                <div class="d-flex justify-content-center align-items-center p-3">
                    <b-spinner />
                </div>
            </b-col>
            <b-col v-show="!is_searching_subs" cols="12">
                <div :class="[{ 'border-top border-color-gray-400 pt-3 mt-3': !!searched_subs.length || (is_empty_searched_subs == true && (message !== '' && message !== null))}]">
                    <template v-if="is_empty_searched_subs == true && (message !== '' && message !== null)">
                        <div class="border border-color-gray-300 bgray-200 f-90 p-3 rounded"> {{ message }} </div>
                    </template>
                    <template v-else>
                        <draggable :list="searched_subs" group="subs">
                            <editing-searched-sub-component v-for="(sub, s) in searched_subs"
                                :key="`sub-${sub.sub_code}-${s}`"
                                :id="`sub-${sub.sub_code}-${s}`"
                                :sub="sub"
                                @make-next-version-success="renewSearch"
                                />
                        </draggable>
                    </template>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import { mapState } from 'vuex'
import draggable from 'vuedraggable'
import editingSearchedSubComponent from '@core_components/admin/components/subs/EditingSearchedSubComponent'

export default {
    name: 'SubFinder',
    components: {
        editingSearchedSubComponent,
        draggable
    },
    data () {
        return {
            search_keyword : '',
            message: '',
            is_searching_subs: false
        }
    },
    computed: {
        ...mapState(['show_sub_finder']),
        searched_subs () {
            return this.$store.getters.getSearchedSubs
        },
        is_empty_searched_subs () {
            return this.$store.getters.isEmptySearchedSubs
        }
    },
    watch: {
        show_sub_finder (_status) {
            if (!_status) {
                this.is_searching_subs = false
            }
        }
    },
    created () {
        this.$store.commit('reset_searched_subs')
    },
    methods: {
        toggleSide () {
            this.$emit('toggle-side', this.is_side_collapsed)
        },
        async searchSubs (search_keyword) {
            this.is_searching_subs = true
            await this.$store.dispatch('readSearchedSubs', search_keyword)
            if (this.is_empty_searched_subs === true) {
                this.message = this.search_keyword + '에 대한 검색결과가 없습니다. 다시 검색해주세요.'
            }
            this.is_searching_subs = false
        },
        async renewSearch (nextSubCode) {
            this.is_searching_subs = true
            this.search_keyword = nextSubCode
            await this.$store.dispatch('readSearchedSubs', this.search_keyword)
            if (this.is_empty_searched_subs === true) {
                this.message = this.search_keyword + '에 대한 검색결과가 없습니다. 다시 검색해주세요.'
            }
            this.is_searching_subs = false
        }
    }
}
</script>

<style scoped>

.ih-table-head {
    background-color:#333333;
    color: white;
}

.btn-right-collapse {
    height: 100vh;
    background-color: rgba(0,0,0,0);
    color: var(--gray-600);
    position: fixed;
    z-index: 50;
    top:0;
    right:0;
}
.btn-right-collapse:hover, .btn-right-collapse:focus {
    background-color: rgba(0,0,0,0.2);
    color: var(--gray-700);
}

</style>
